import React, { FunctionComponent, MouseEvent } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';
import expandedSectionStyles from '../ExpandedSectionStyles';
import { IPrice } from '../../../../../../../../../common/model/IPrice';
import dealPriceAccessor from '../../../../../../../common/service/dealPriceAccessor';
import usePlatformConfig from '../../../../../../../common/react/usePlatformConfig';
import ICarConfigOption from '../../../../../../../../../common/model/ICarConfigOption';
import { CustomiseSections } from '../../../../../../../common/enum/CustomiseSections';
import OptionItem from './OptionItem';
import IndicativeNumber from '../../../../../../../common/components/indicativeNumber/IndicativeNumber';
import ShowIfTranslationExists from '../../../../../../../common/components/ShowIfTranslationExists';
import Translation from '../../../../../../../common/components/translation/Translation';
import useWidgetContext from '../../../../../../../common/react/useWidgetContext';
import handleFeatureAccessoryDataLayerRest from '../../../../../../../common/utils/dataLayer/rest/handleFeatureAccessoryDataLayerRest';

export interface IAccessoriesSectionProps {
  accessories: ICarConfigOption[];
  removeAction: (category: string, optionId?: string) => void;
  isSecondaryCurrencyDisplay: boolean;
  scrollToDisclaimer: (e: MouseEvent<HTMLAnchorElement> | MouseEvent<HTMLButtonElement>) => void;
}

const AccessoriesSection: FunctionComponent<IAccessoriesSectionProps> = ({
  accessories,
  removeAction,
  isSecondaryCurrencyDisplay,
  scrollToDisclaimer,
}) => {
  const styles = expandedSectionStyles();
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const {
    configuration: { dimensions },
  } = useWidgetContext();

  const removeActionHandler = (category: string, optionId?: string) => {
    removeAction(category, optionId);
    handleFeatureAccessoryDataLayerRest(null, false, dimensions, accessories, optionId);
  };

  return (
    <Grid item={true}>
      <Typography variant={'body1'} className={clsx([styles.bolded, styles.subtitle])}>
        <Box display={'flex'} flexDirection={'inline'} component={'span'} className={styles.bolded}>
          <Translation id={'spc.customise.accessories.title'} />
          <IndicativeNumber
            dataTest="accessories"
            displayNumber={<Translation id={'spc.customise.indicative.accessories'} />}
            onClick={scrollToDisclaimer}
          />
          <ShowIfTranslationExists translationKey="spc.customise.accessories.subtitle">
            <>
              <Box component="span" ml={0.5} mr={0.5}>
                -
              </Box>
              <Typography component="span" className={styles.bolded}>
                <Translation id={'spc.customise.accessories.subtitle'} />
              </Typography>
            </>
          </ShowIfTranslationExists>
        </Box>
      </Typography>
      {accessories.map((option: ICarConfigOption) => {
        const price: IPrice = isSecondaryCurrencyDisplay
          ? dealPriceAccessor.getSecondaryPrice(option.prices, priceDisplay)
          : dealPriceAccessor.getPrimaryPrice(option.prices, priceDisplay);

        return (
          <OptionItem
            key={option.id}
            option={option}
            price={price}
            category={CustomiseSections.ACCESSORIES}
            removeAction={removeActionHandler}
            decimalScale={priceDisplay.primaryOptions.decimalScale}
          />
        );
      })}
    </Grid>
  );
};

export default AccessoriesSection;
